import * as React from 'react';

import type { CmlContent } from '__generated__/graphql-types';

import type { FaqModuleItem } from 'bundles/cds-labs/components/Modules/FAQsModule';
import FAQsModule from 'bundles/cds-labs/components/Modules/FAQsModule';
import { CML, toPlainText } from 'bundles/cml';
import { useVisibilityTracker } from 'bundles/page/lib/event-pulse/react';
import HelpCenterInfo from 'bundles/unified-common/components/HelpCenterInfo';
import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import convertToCmlContent from 'bundles/unified-description-page-common/utils/convertToCmlContent';

type Props = {
  pageData: ConsumerCoursePageFieldsFragment | ConsumerSpecializationPageFieldsFragment;
  config?: {
    disableCta?: boolean;
  };
};

const FAQsModuleRenderer = ({ pageData, config }: Props) => {
  const eventingProductData = useEventingProductData();

  const visibilityTrackingRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_page_section',
    {
      pageSection: {
        sectionName: 'faq',
      },
      ...eventingProductData,
    }
  );

  const convertedFaqs = pageData.cmlFaqs?.map((faq): FaqModuleItem => {
    return {
      question: toPlainText(convertToCmlContent(faq.question as CmlContent)) || '',
      answer: <CML cml={faq.answer as CmlContent} />,
    };
  });

  return (
    <Section ref={visibilityTrackingRef}>
      <FAQsModule
        faqs={convertedFaqs}
        moreInfo={!config?.disableCta && <HelpCenterInfo />}
        accordionTrackingData={eventingProductData}
      />
    </Section>
  );
};

export default FAQsModuleRenderer;
